//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Builder.js";
import "../no/SelectNXObject.js";
import "../no/SelectNXObjectList.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[1,"Centerline",0,"SelectNXObject",0],[0,"ConstraintType",1,0],[1,"GeometryToConstrain",0,"SelectNXObjectList",0],[1,"GeometryToConstrainTo",0,"SelectNXObject",0],[0,"MakeReference",1,0],[0,"UpdateSketchAtCommit",1,0]],[],[]];
SPLM.SketchConstraintBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.SketchConstraintBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.SketchConstraintBuilder.Constraint = Object.freeze({
    "Coincident" : "Coincident", "PointOnCurve" : "PointOnCurve", "Tangent" : "Tangent", "Parallel" : "Parallel", "Perpendicular" : "Perpendicular", "Horizontal" : "Horizontal", "Vertical" : "Vertical", "HorizontalAlignment" : "HorizontalAlignment", "VerticalAlignment" : "VerticalAlignment", "Midpoint" : "Midpoint", "Collinear" : "Collinear", "Concentric" : "Concentric", "EqualLength" : "EqualLength", "EqualRadius" : "EqualRadius", "Symmetric" : "Symmetric", "Fixed" : "Fixed", "FullyFixed" : "FullyFixed", "ConstantAngle" : "ConstantAngle", "ConstantLength" : "ConstantLength", "PointOnString" : "PointOnString", "TangentToString" : "TangentToString", "PerpendicularToString" : "PerpendicularToString", "NonUniformScale" : "NonUniformScale", "UniformScale" : "UniformScale", "SlopeOfCurve" : "SlopeOfCurve"});

export default SPLM;